var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiSearchLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 27.695L37.1902 34.8317L34.8318 37.19L27.6952 30.0517C25.0397 32.1804 21.7368 33.3382 18.3335 33.3333C10.0535 33.3333 3.3335 26.6133 3.3335 18.3333C3.3335 10.0533 10.0535 3.33334 18.3335 3.33334C26.6135 3.33334 33.3335 10.0533 33.3335 18.3333C33.3383 21.7367 32.1805 25.0396 30.0518 27.695ZM26.7085 26.4583C28.8232 24.2829 30.0044 21.3673 30.0002 18.3333C30.0002 11.8883 24.7785 6.66667 18.3335 6.66667C11.8885 6.66667 6.66683 11.8883 6.66683 18.3333C6.66683 24.7783 11.8885 30 18.3335 30C21.3674 30.0043 24.283 28.8231 26.4585 26.7083L26.7085 26.4583Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiSearchLine);
export default __webpack_public_path__ + "static/media/ri_search-line.86cee5ae0060487b7df0bc756ec7fc40.svg";
export { ForwardRef as ReactComponent };